import { Icon, IconProps } from './Icon';

export const ExitIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 29 28"
  >
    <path
      d="M22.9261 12.4255C24.1382 13.1253 24.1382 14.8749 22.926 15.5747L18.4596 18.1534C17.2475 18.8532 15.7323 17.9784 15.7323 16.5788L15.7323 11.4214C15.7323 10.0218 17.2475 9.14699 18.4596 9.84681L22.9261 12.4255Z"
      fill="#C2E2FF"
    />
    <path
      d="M23.5625 5.37786C23.5625 6.38202 22.7485 7.19604 21.7443 7.19604H15.3797C14.3756 7.19604 13.5615 8.01007 13.5615 9.01423V18.9853C13.5615 19.9894 14.3756 20.8035 15.3797 20.8035H21.7443C22.7485 20.8035 23.5625 21.6175 23.5625 22.6216V24.4511C23.5625 25.4553 22.7485 26.2693 21.7443 26.2693H6.65314C5.64899 26.2693 4.83496 25.4553 4.83496 24.4511V3.54938C4.83496 2.54523 5.64899 1.7312 6.65314 1.7312H21.7443C22.7485 1.7312 23.5625 2.54523 23.5625 3.54938V5.37786Z"
      fill="#C2E2FF"
    />
  </Icon>
);
